<template>
  <div v-if="showModuloForm === false">
    <MarketingModules></MarketingModules>
  </div>
  <div class="page" v-else-if="showModuloForm === true">
    <Panel lineColor="var(--primary-color)">
      <v-row class="mb-5">
        <v-col>
          <v-slide-group v-model="slideStatus" multiple show-arrows>
            <v-slide-item
              v-for="(s, i) in statusOrder"
              :key="i"
              v-slot="{ active, toggle }"
            >
              <div class="badge-container">
                <v-btn
                  class="btn-badge px-1"
                  :class="active ? '' : 'black--text'"
                  small
                  :color="active ? 'primario' : 'grey lighten-2'"
                  depressed
                  rounded
                  @click="toggle"
                >
                  {{ s.text }}
                  <span class="badge" v-if="s.value != 'TODOS'">{{
                    totalOrderStatus[s.value] || 0
                  }}</span>
                  <span class="badge" v-else> {{ ordersTotal || 0 }}</span>
                </v-btn>
              </div>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
      <DataTable
        :headers="headers"
        :endpoint="endpoint"
        :filters="filters"
        :additionalData="filterOrderStatus"
        noHideFilters
        :auto-search="false"
        sortBy="numpedido"
        :sortDesc="true"
        ref="datatable"
        @click="onClick"
        @set-value-filter="getTotalStatusOrder"
        :limitPage="[15, 25, 50, 100, 200]"
        :itemsPerPage="25"
      >
        <template v-slot:numpedido="{ row }">
          <div class="font-weight-bold">{{ row.numpedido }}</div>
          <div>{{ row.datapedido | formatDateTime }}</div>
          <div v-if="row.totalliquido">
            {{ formatarTotal(row.totalliquido) | formatMoney }}
          </div>
          <div v-else>{{ 0 | formatMoney }}</div>
          <div v-if="row.id_pedido_erp">ID no erp: {{ row.id_pedido_erp }}</div>
          <div v-if="row.num_pedido_cliente">
            Nº Ped Cliente: {{ row.num_pedido_cliente }}
          </div>
        </template>
        <template v-slot:canal_venda="{ col }">
          <v-chip small :color="getCanalVendaColor(col)">{{
            getCanalVendaText(col)
          }}</v-chip>
        </template>
        <template v-slot:nome_cliente="{ row }">
          <div class="font-weight-bold">
            {{ row.nome_cliente }}
            <span v-if="row.id_cliente_erp">
              - Cod ERP:{{ row.id_cliente_erp }}
            </span>
          </div>

          <v-chip
            small
            class="font-weight-bold primeiracompra"
            v-if="row.primeira_compra"
          >
            <v-icon class="mr-3" size="14">fas fa-shopping-basket</v-icon>
            Primeira compra
          </v-chip>
          <div>{{ row.email }}</div>
          <div>{{ row.telefone }}</div>
        </template>
        <template v-slot:tipo_entrega="{ col }">
          <v-chip
            small
            color="primary"
            v-if="col == 'RETIRADA'"
            class="font-weight-bold"
          >
            Retirada
          </v-chip>
          <v-chip
            small
            color="success"
            v-else-if="col == 'DELIVERY'"
            class="font-weight-bold"
          >
            Delivery
          </v-chip>
          <v-chip small color="secondary" v-else class="font-weight-bold">
            {{ col }}
          </v-chip>
        </template>
        <template v-slot:statuspedido="{ col }">
          <v-chip
            small
            :color="getStatusPedidoColor(col)"
            class="font-weight-bold"
          >
            {{ getStatusPedido(col) }}
          </v-chip>
        </template>
        <template v-slot:pedidooriginal="{ row, col }">
          <span v-if="col">
            <span v-if="col === row.numpedido">
              <v-chip small color="secondary" class="font-weight-bold">
                <v-icon class="mr-3" size="14">fa-exclamation-circle</v-icon>
                Origem
              </v-chip>
            </span>
            <span v-else>
              <v-chip
                small
                color="primary"
                class="font-weight-bold"
                @click="onClickBreak(row)"
              >
                <v-icon class="mr-2" size="14">fa-share</v-icon>
                {{ col }}
              </v-chip>
            </span>
          </span>
        </template>
        <template v-slot:mensagens_nao_lidas="{ col }">
          <v-chip
            small
            class="font-weight-bold"
            :color="col > 0 ? 'warning' : ''"
          >
            <v-icon class="mr-3" size="14">fa fa-comments</v-icon>
            {{ col }}
          </v-chip>
        </template>
        <template v-slot:idpedido="{ row }">
          <FormButtonMenu
            icon
            :options="tableOptions"
            :loading="loadingRow[row.idpedido]"
            @click="op => selectOption(row, op)"
          >
            <v-icon size="15">fas fa-ellipsis-v</v-icon>
          </FormButtonMenu>
        </template>
      </DataTable>
    </Panel>
    <transition name="slide-popup" mode="out-in">
      <router-view class="view" @close="onClose"></router-view>
    </transition>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import Panel from "@/components/Panel";
import FormButtonMenu from "@/components/form/FormButtonMenu";
import MarketingModules from "@/components/MarketingModules";
import { mapGetters } from "vuex";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import { PEDIDO_STATUS_TOTAL, PEDIDO_UF } from "@/store/actions/pedido";
import OrderStatus from "../../../utils/orderStatus";

export default {
  name: "PedidoTable",
  components: {
    DataTable,
    Panel,
    FormButtonMenu,
    MarketingModules
  },
  data: () => ({
    isLoading: false,
    headers: [
      {
        text: "Quebra de pedido",
        value: "pedidooriginal",
        align: "center",
        clickable: false
      },
      { text: "Pedido", value: "numpedido" },
      { text: "Origem", value: "canal_venda", align: "center" },
      { text: "Cliente", value: "nome_cliente" },
      { text: "Cidade/UF", value: "cidade_uf", align: "center" },
      { text: "Tipo entrega", value: "tipo_entrega", align: "center" },
      { text: "Agendamento", value: "dataentrega" },
      { text: "Status", value: "statuspedido", align: "center" },
      {
        text: "Mensagens não lidas",
        value: "mensagens_nao_lidas",
        align: "center"
      },
      { text: "Opções", value: "idpedido", clickable: false }
    ],
    tableOptions: [{ text: "Detalhes", value: "details" }],
    loadingRow: {},
    slideStatus: [],
    filterOrderStatus: { statuspedido: null },
    totalOrderStatus: {},
    modulosForm: [
      ModulesEnum.PAINEL_CLIENTE,
      ModulesEnum.ORCAMENTO_WEB,
      ModulesEnum.ORCAMENTO_APP,
      ModulesEnum.VENDAMAIS_WEB,
      ModulesEnum.VENDAMAIS_APP,
      ModulesEnum.WEB_COMMERCE,
      ModulesEnum.COMMERCE_APP
    ],
    modulosOrcamento: [ModulesEnum.ORCAMENTO_WEB, ModulesEnum.ORCAMENTO_APP],
    estadosOptions: PEDIDO_UF
  }),
  computed: {
    ...mapGetters([
      "getFornecedorId",
      "moduloFornecedorAtivo",
      "getFornecedorTag"
    ]),
    filters() {
      return [
        { label: "Pedido", query: "numpedido" },
        { label: "Nome, E-mail ou Documento do cliente", query: "cliente" },
        {
          label: "Data inicial",
          query: "data_inicial",
          type: "date"
        },
        {
          label: "Data final",
          query: "data_final",
          type: "date"
        },
        {
          label: "Cidade",
          query: "cidade"
        },
        {
          label: "Estado",
          query: "uf",
          default: "",
          clearable: "true",
          options: this.estadosOptions
        },
        {
          label: "Tipo de Entrega",
          query: "tipoentrega",
          default: "TODOS",
          clearable: "false",
          options: [
            { text: "Todos", value: "TODOS" },
            { text: "Delivery", value: "DELIVERY" },
            { text: "Retirada", value: "RETIRADA" }
          ]
        },
        {
          label: "Canal de venda",
          query: "canalvenda",
          type: "select",
          multiple: true,
          clearable: "false",
          default: ["APP", "WEB", "INTEGRACAO", "MANUAL", "LIFEGROWTH"],
          options: [
            { text: "App", value: "APP" },
            { text: "Site", value: "WEB" },
            { text: "Erp", value: "INTEGRACAO" },
            { text: "Venda +", value: "MANUAL" },
            { text: "LifeGrowth", value: "LIFEGROWTH" }
          ]
        },
        {
          label: "Forma de pagamento",
          query: "formapagamento",
          type: "autocomplete",
          multiple: true,
          request: {
            value: "idformapagto",
            text: "description",
            endpoint: `/api/v4/payment-method/${this.getFornecedorId}`,
            query: "search"
          }
        },
        {
          label: "Pedido(s) com Corte",
          query: "possuicorte",
          default: "TODOS",
          clearable: "false",
          options: [
            { text: "Todos", value: "TODOS" },
            { text: "Sim", value: "SIM" },
            { text: "Não", value: "NAO" }
          ]
        },
        {
          label: "Pedido(s) com Quebra",
          query: "possuiquebra",
          default: "TODOS",
          clearable: "false",
          options: [
            { text: "Todos", value: "TODOS" },
            { text: "Sim", value: "SIM" },
            { text: "Não", value: "NAO" }
          ]
        },
        {
          label: "Pedido(s) de primeira compra",
          query: "primeiracompra",
          default: "TODOS",
          clearable: "false",
          options: [
            { text: "Todos", value: "TODOS" },
            { text: "Sim", value: "SIM" },
            { text: "Não", value: "NAO" }
          ]
        }
      ];
    },
    endpoint() {
      return `/api/v4/orders/listForTable/${this.getFornecedorId}`;
    },
    supportBudget() {
      return this.getFornecedorTag["support-budget"];
    },
    showModuloForm() {
      return this.moduloFornecedorAtivo(this.modulosForm);
    },
    statusOrder() {
      if (this.moduloFornecedorAtivo(this.modulosOrcamento)) {
        return OrderStatus.OrderStatusFilter;
      }
      return OrderStatus.OrderStatusFilter.filter(
        item =>
          item.value !== "ORCAMENTO_NOVO" &&
          item.value !== "ORCAMENTO_PRECIFICADO"
      );
    },
    statusOrderSing() {
      return OrderStatus.OrderStatusFilterSing;
    },
    ordersTotal() {
      return Object.values(this.totalOrderStatus)
        .map(Number)
        .reduce((acc, current) => acc + current, 0);
    }
  },
  methods: {
    onClick(item) {
      const url = this.$router.resolve({
        path: `pedidos/detalhes/${item.numpedido}`
      }).href;
      window.open(url, "_blank");
    },
    onClickBreak(item) {
      const url = this.$router.resolve({
        path: `pedidos/detalhes/${item.pedidooriginal}`
      }).href;
      window.open(url, "_blank");
    },
    onClose() {
      this.$refs.datatable.reload();
      this.loadingRow = {};
    },
    selectOption(item, option) {
      switch (option.value) {
        case "details":
          return this.onClick(item);
      }
    },
    formatarTotal(valor) {
      if (!valor) return 0;
      const numero = parseFloat(valor);
      if (isNaN(numero)) return 0;
      return numero.toFixed(2);
    },
    getTotalStatusOrder(value) {
      this.isLoading = true;
      let filtro;
      if (value && value.filtrosAvancados) {
        filtro = value.filtrosAvancados;
      } else {
        filtro = value;
      }
      const numpedido = filtro.filter(f => f.query == "numpedido")[0];
      const cliente = filtro.filter(f => f.query == "cliente")[0];
      const dtIni = filtro.filter(f => f.query == "data_inicial")[0];
      const dtFim = filtro.filter(f => f.query == "data_final")[0];
      const tipoEntregaFiltro = filtro.filter(f => f.query == "tipoentrega")[0];
      const cidadeFiltro = filtro.filter(f => f.query == "cidade")[0];
      const ufFiltro = filtro.filter(f => f.query == "uf")[0];
      const formaPagamento = filtro.filter(f => f.query == "formapagamento")[0];
      const canalVendaFiltro = filtro.filter(f => f.query == "canalvenda")[0];
      const possuiCorte = filtro.filter(f => f.query == "possuicorte")[0];
      const possuiQuebra = filtro.filter(f => f.query == "possuiquebra")[0];
      const primeiraCompra = filtro.filter(f => f.query == "primeiracompra")[0];

      const canalVendaRaw =
        canalVendaFiltro &&
        canalVendaFiltro.value != null &&
        canalVendaFiltro.value !== "" &&
        !(
          Array.isArray(canalVendaFiltro.value) &&
          canalVendaFiltro.value.length === 0
        )
          ? canalVendaFiltro.value
          : canalVendaFiltro && canalVendaFiltro.default != null
          ? canalVendaFiltro.default
          : null;
      const canalVenda = Array.isArray(canalVendaRaw)
        ? canalVendaRaw.join(",")
        : canalVendaRaw
        ? String(canalVendaRaw)
        : "INTEGRACAO,APP,WEB,MANUAL,LIFEGROWTH";

      const data = {
        numpedido: numpedido && numpedido.value ? numpedido.value : "",
        cliente: cliente && cliente.value ? cliente.value : "",
        dtIni: dtIni && dtIni.value ? dtIni.value : "",
        dtFim: dtFim && dtFim.value ? dtFim.value : "",
        tipoEntrega:
          tipoEntregaFiltro && tipoEntregaFiltro.value != null
            ? tipoEntregaFiltro.value
            : "TODOS",
        ativo: true,
        formaPagamento:
          formaPagamento && formaPagamento.value ? formaPagamento.value : "",
        possuiCorte: possuiCorte && possuiCorte.value ? possuiCorte.value : "",
        possuiQuebra:
          possuiQuebra && possuiQuebra.value ? possuiQuebra.value : "",
        primeiraCompra:
          primeiraCompra && primeiraCompra.value ? primeiraCompra.value : "",
        cidade: cidadeFiltro && cidadeFiltro.value ? cidadeFiltro.value : "",
        uf: ufFiltro && ufFiltro.value ? ufFiltro.value : "",
        canalVenda
      };

      this.$store
        .dispatch(PEDIDO_STATUS_TOTAL, data)
        .then(data => {
          this.totalOrderStatus = data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getCanalVendaText(canalVenda) {
      switch (canalVenda) {
        case "APP":
          return "App";
        case "WEB":
          return "Site";
        case "INTEGRACAO":
          return "Erp";
        case "MANUAL":
          return "Venda +";
        case "VENDEDOR":
          return "Vendedor";
        case "LIFEGROWTH":
          return "LifeGrowth";
      }
    },
    getCanalVendaColor(canalVenda) {
      switch (canalVenda) {
        case "APP":
          return "primary";
        case "WEB":
          return "success";
        case "INTEGRACAO":
          return "secondary";
        case "MANUAL":
          return "warning";
        case "VENDEDOR":
          return "error";
        case "LIFEGROWTH":
          return "info";
      }
    },
    getStatusPedido(status) {
      return this.statusOrderSing.reduce((acc, current) => {
        acc[current.value] = current.text;
        return acc;
      })[status];
    },
    getStatusPedidoColor(status) {
      return OrderStatus && OrderStatus.OrderStatusColor
        ? OrderStatus.OrderStatusColor[status]
        : "";
    }
  },
  watch: {
    slideStatus(newValue) {
      this.filterOrderStatus.statuspedido = newValue.map(
        index => this.statusOrder[index].value
      );
    }
  },
  created() {
    if (this.moduloFornecedorAtivo(this.modulosOrcamento)) {
      if (this.supportBudget) {
        this.filterOrderStatus.statuspedido = ["ORCAMENTO_NOVO"];
        this.slideStatus = [1];
      } else {
        this.filterOrderStatus.statuspedido = ["ENVIADO"];
        this.slideStatus = [3];
      }
    } else {
      this.filterOrderStatus.statuspedido = ["ENVIADO"];
      this.slideStatus = [1];
    }
    this.getTotalStatusOrder(this.filters);
  }
};
</script>

<style lang="scss" scoped>
.badge-container {
  position: relative;
  padding-top: 10px;
  display: inline-block;
}
.badge {
  position: absolute;
  top: -17px;
  right: -10px;
  background-color: #7e7675;
  font-weight: bold;
  color: white;
  border-radius: 25px;
  padding: 4px;
  font-size: 10px;
  min-width: 25px;
}

.btn-badge {
  font-size: 0.65em;
  letter-spacing: 0.1px;
  font-weight: bold;
  margin-left: 3px;
}

.primeiracompra,
.primeiracompra i {
  background-color: seagreen !important;
  color: white !important;
}
</style>
